<ng-template>
  <div class="select-trigger">
    @if (!hasValue) {
      <div class="placeholder">{{ placeholder }}</div>
    }
    <ng-content></ng-content>
  </div>
</ng-template>
